// extracted by mini-css-extract-plugin
export default {"cls1":"AttachmentOverlay-cls1__aa3e5ac365791e4baf2c","cls2":"AttachmentOverlay-cls2___a34bd5a523c520d5f0d AttachmentOverlay-cls1__aa3e5ac365791e4baf2c"};